import { useCallback, useEffect } from 'react';
import { useCanViewCollectionView } from '@shared/data/billing/hooks/useCanViewCollectionView';
import { MBAnalytics } from '@shared/util/analytics';

export function useTrackPaywallClick() {
  return useCallback(() => {
    MBAnalytics.track('Paywall::Click');
  }, []);
}

export function useTrackPaywallView() {
  const isPaid = useCanViewCollectionView();

  useEffect(() => {
    if (isPaid) {
      return;
    }
    MBAnalytics.track('Paywall::View');
  }, [isPaid]);
}
